import eventQueue from '../queue';
import { EventAction, EventSurface } from '../../types/events';
import { checkLinkApiRequestParamsLengthAndContainsKeys } from '../utils';
function attachEventListeners() {
    eventQueue.on('state', function (_a) {
        var state = _a.state, action = _a.action, fireAnalyticsEvent = _a.fireAnalyticsEvent;
        if (action === 'linkApi/next/pending' &&
            (state.segment.currentSource ===
                EventSurface.PROVIDER_CONFIRMATION_BOUNDED ||
                state.segment.currentSource ===
                    EventSurface.PROVIDER_CONFIRMATION_PRIMER)) {
            fireAnalyticsEvent(EventAction.PROVIDER_CONFIRMED, {
                platformIdOverride: state.linkApi.context.platform.id,
            });
        }
    });
    eventQueue.on('link_api_request', function (_a) {
        var state = _a.state, params = _a.params, fireAnalyticsEvent = _a.fireAnalyticsEvent;
        if (checkLinkApiRequestParamsLengthAndContainsKeys(params, ['id', 'response_type'], 2) &&
            'payload' in params.body &&
            state.segment.currentSource ===
                EventSurface.PROVIDER_CONFIRMATION_UNBOUNDED) {
            var payload = params.body.payload;
            // eslint-disable-next-line dot-notation
            if (payload['response_type'] === 'platform') {
                fireAnalyticsEvent(EventAction.PROVIDER_CONFIRMED, {
                    // eslint-disable-next-line dot-notation
                    platformIdOverride: payload['id'],
                });
            }
            else {
                fireAnalyticsEvent(EventAction.PROVIDER_CONFIRMED, {
                    // eslint-disable-next-line dot-notation
                    employerIdOverride: payload['id'],
                });
            }
        }
    });
}
attachEventListeners();
